import Shop from '../shop';

export default class DrugRing extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Drug ring',
            id:                   'DrugRing',
            coolDown:             9000,
            faClass:              'fae-injection',
            individualCostFactor: 1.1,
            baseEarnings:         154792512000.0,
            baseCosts:            3715041853440.0,
            grade:                12
        });
    }
}
